// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Categories
export const CATEGORIES = [
  { value: "all", label: "All Recipes" },
  { value: "breakfast", label: "Breakfast" },
  { value: "lunch", label: "Lunch" },
  { value: "dinner", label: "Dinner" },
  { value: "desserts", label: "Desserts" },
  { value: "snacks", label: "Snacks" },
  { value: "appetizers", label: "Appetizers" }
];
